import { sliceLoadFail, sliceLoadStart } from 'utils/tools/slice-actions';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

import { createSlice } from 'utils/@reduxjs/toolkit';
import { preRoutingSaga } from './saga';

export const initialState = {
  loading: false,
  error: null,
  relatedApps: [],
  downloadLink: null,
  latestVersion: null,
  latestVersionLoading: false,
};

const slice = createSlice({
  name: 'preRouting',
  initialState,
  reducers: {
    resetState(state) {
      state = initialState;
    },
    loadInstallDataStart(state) {
      sliceLoadStart(state);
    },
    loadInstallDataSuccess(state, action) {
      state.relatedApps = action.payload?.relatedApps;
      state.downloadLink = action.payload?.downloadLink;
      state.loading = false;
    },
    loadInstallDataFail(state, action) {
      sliceLoadFail(state, action);
    },
    fetchLatestVersionStart(state, action) {
      sliceLoadStart(state);
      state.latestVersionLoading = true;
    },
    fetchLatestVersionSuccess(state, action) {
      state.latestVersion = action.payload?.web_version;
      state.loading = false;
      state.latestVersionLoading = false;
    },
    fetchActionError(state, action) {
      sliceLoadFail(state, action);
    },
  },
});

export const { actions: preRoutingActions, reducer } = slice;

export const usePreRoutingSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: preRoutingSaga });
  return { actions: slice.actions };
};
